export default __webpack_public_path__ + "static/media/designdiwali2056.4833a1ea.png";